<template>
  <div class="pcheader">
    <div class="container">
      <div class="fl title"><a @click.stop="homeback">志愿者</a></div>
      <ul class="fr navul">
        <li><a @click.stop="addvolunteer">志愿者招募</a></li>
        <li><a @click.stop="volunteeractivity">志愿者活动</a></li>
        <li v-show="myflags"><a @click.stop="myvolunteer">我的活动</a></li>
        <!--<li><a>相关报道</a></li>-->
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pcheader',
  props: ['myflags'],
  data () {
    return {
      myflag: false
    }
  },
  mounted () {

  },
  methods: {
    homeback () {
      this.$router.push({
        path: `/volunteer`,
        query: {museumCode: this.$cookie.get('museumCode')}
      })
    },
    myvolunteer () {
      this.$router.push({
        path: `/myvolunteeractivity`,
        query: {museumCode: this.$cookie.get('museumCode')}
      })
    },
    addvolunteer () {
      this.$http({
        url: this.$http.adornUrl(`/api/volunteer/web/volunteer/service-info`),
        method: 'get'
      }).then((res) => {
        if (res) {
          if (res.data.rel === true) {
            if (res.data.data === '') {
              this.$router.push({path: '/volunteermuseum', query: {museumCode: this.$cookie.get('museumCode')}})
            } else {
              this.$router.push({path: '/volunteerinfomuseumedit', query: {museumCode: this.$cookie.get('museumCode')}})
            }
          } else {
            if (res.data.data === '你没有志愿者信息。') {
              this.$router.push({path: '/volunteerinfo', query: {museumCode: this.$cookie.get('museumCode')}})
            }
          }
        } else {
          this.$message.error(res.data.data)
        }
      })
    },
    // 跳转志愿者活动
    volunteeractivity () {
      this.$router.push({
        path: `/volunteeractivity`,
        query: {museumCode: this.$cookie.get('museumCode')}
      })
    }
  }
}
</script>

<style lang="scss">
  .pcheader{
    height: 90px;
    background: #a11b00;
    .title{
      font-size: 30px;
      color: #fff;
      padding: 22px 0 0;
    }
    .navul{
      padding: 30px 0 0;
      li{
        float: left;
        font-size: 16px;
        margin: 0 0 0 15px;
        padding: 0px 20px;
        border: solid 1px #fff;
        height: 30px;
        line-height: 30px;
        color: #fff;
        -webkit-border-radius: 15px;
        -moz-border-radius: 15px;
        border-radius: 15px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/common/pcheader.vue